module.exports = __webpack_public_path__ + "8d4ef88eb4d4622790794b243bdde9ea.jpg";